import React, { useState, useContext } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";

import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import ThreeDRotation from "@material-ui/icons/ThreeDRotation";
import MenuIcon from "@material-ui/icons/Menu";
import {
  Typography,
  IconButton,
  Button,
  Fade,
  Menu as MyMenu,
  MenuItem as MyMenuItem,
} from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import "../assets/css/sidebar.scss";
import profile from "../assets/images/avatar.png";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import GroupIcon from "@material-ui/icons/Group";
import UnsubscribeIcon from "@material-ui/icons/Unsubscribe";
import ViewListOutlinedIcon from "@material-ui/icons/ViewListOutlined";
import IconMenu from "../assets/images/menu.png";
import Logo from "../assets/images/deshipay-logo.png";

import myHome from "../assets/images/home.svg";
import gift from "../assets/images/gift.png";
import sign from "../assets/images/sign.png";
import edit2 from "../assets/images/edit2.png";
import list from "../assets/images/list.png";
import manage_role from "../assets/images/manage_role.png";
import view_role from "../assets/images/view_role.png";
import create_role from "../assets/images/create_role.png";
import lock from "../assets/images/lock.svg";
import userAdd from "../assets/images/userAdd.svg";
import faq from "../assets/images/faq.png";
import notificationList from "../assets/images/notificationList.png";
import send from "../assets/images/send.png";
import video from "../assets/images/video.svg";
import bell from "../assets/images/bell.png";
import analyticsIcon from "../assets/images/analytics.svg";
import GetAppIcon from "@material-ui/icons/GetApp";

import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
} from "react-pro-sidebar";
import { AuthContext } from "../context/AuthContext";

const useStyles = makeStyles({
  logo: {
    marginLeft: 15,
    fontWeight: 600,
    fontSize: "1.3rem",
    flexGrow: 1,
    marginTop: 7,
  },
  sidebar: {
    minHeight: "100vh",
  },
  profile: {
    position: "absolute",
    right: 15,
    top: -7,
  },
  header: {
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
  },
  sidebarHeader: {
    borderBottom: "0px solid #ddd !important",
  },
  icon: {
    color: "#fff",
    marginLeft: 15,
  },
  menu_title: {
    fontSize: "1rem",
    fontWeight: 500,
  },
  link: {
    color: "#fff",
    textDecoration: "none",
  },
  link2: {
    color: "#333",
    textDecoration: "none",
  },
  topBar: {
    height: 64,
    background: "#fff",
    width: "100%",
    position: "absolute",
    boxShadow: "1px 1px 3px 1px #ddd",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  menuButton: {
    marginRight: 15,
  },

  iconImageSub: {
    position: "relative",
    top: 5,
    width: 20,
    marginRight: 15,
    paddingLeft: 7,
  },
  promo:{
    width: 24,
    height: 24,
    opacity: 0.7,
    color: 'red'
  }
  ,
  account: {
    fontSize: 45,
    marginTop: 10,
    color: "#00824D",
  },
});

const SideBar = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const path = location.pathname;

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const { logout, auth } = useContext(AuthContext);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logOut = () => {
    setAnchorEl(null);
    logout();
  };

  const changePassword = () => {
    history.push("/change-password");
  };

  const handleToggleSidebar = () => {
    setToggled(!toggled);
  };
  return (
    <>
      <div>
        <div className={classes.topBar}>
          <Typography variant="h6" color="primary">
            Marketing Panel
          </Typography>
          <div className={classes.profile}>
            <Button
              aria-controls="fade-menu"
              aria-haspopup="true"
              onClick={handleClick}
              style={{ backgroundColor: "transparent" }}
            >
              {/* <img src={profile} alt="" /> */}
              <AccountCircleIcon className={classes.account} />
            </Button>
            <MyMenu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MyMenuItem onClick={handleClose} className={classes.menuItem}>
                {/* <img src={profile} alt="" /> */}
                <AccountCircleIcon className={classes.account} />

                <Typography>{auth.user.name} </Typography>
              </MyMenuItem>
              <MyMenuItem onClick={changePassword}>Change Password</MyMenuItem>
              <MyMenuItem onClick={logOut}>Logout</MyMenuItem>
            </MyMenu>
          </div>
        </div>

        <ProSidebar
          collapsed={isCollapsed}
          // breakPoint="sm"
          toggled={toggled}
          onToggle={() => setIsCollapsed(!isCollapsed)}
          className={classes.sidebar}
        >
          <SidebarHeader className={classes.sidebarHeader}>
            <div className={classes.header}>
              <IconButton
                className={classes.menuButton}
                onClick={(e) => setIsCollapsed(!isCollapsed)}
              >
                <img src={IconMenu} alt="" />
              </IconButton>
              {!isCollapsed ? (
                <div className={classes.logo}>
                  <Link to="/">
                    <img src={Logo} alt="" height="60px" />
                  </Link>
                </div>
              ) : null}
            </div>
          </SidebarHeader>
          <Menu iconShape="square">
            {/* home */}
            <MenuItem
              icon={<img src={myHome} alt="" className={classes.iconImage} />}
            >
              <Link to="/" className={path === "/" ? classes.active : ""}>
                Home
              </Link>
            </MenuItem>
            {/* promotions submenu start */}
            <SubMenu
              title="Promotions"
              icon={<img src={gift} alt="" className={classes.iconImage} />}
              className={
                path === "/create-promotion" || path === "/promotion-list"
                  ? classes.active
                  : ""
              }
            >
              {/* create-promotion start */}
              <MenuItem>
                <Link to="/create-promotion">
                  <img src={edit2} alt="" className={classes.iconImageSub} />{" "}
                  Create Promotions
                </Link>
              </MenuItem>
              {/* create-promotion end */}

              {/* promotion list start */}
              <MenuItem>
                <Link to="/promotion-list">
                  <img src={list} alt="" className={classes.iconImageSub} />
                  Promotions List
                </Link>
              </MenuItem>
              {/* promotion list end */}
            </SubMenu>
            {/* promotions submenu end */}

            {/* shop-promo submenu start */}
            <SubMenu
              title="Shop Promos"
              icon={<img src={sign} alt="" className={classes.promo} />}
              className={
                path === "/create-shop-promo" || path === "/shop-promo-list"
                  ? classes.active
                  : ""
              }
            >
              {/* create shop-promo start */}
               <MenuItem>
                <Link to="/create-shop-promo">
                  <img src={edit2} alt="" className={classes.iconImageSub} />{" "}
                  Create Shop Promos
                </Link>
              </MenuItem>
              {/* create-shop-promo end */}
              {/* shop-promos list start */}
              <MenuItem>
                <Link to="/shop-promo-list">
                  <img src={list} alt="" className={classes.iconImageSub} />
                  Shop Promos List
                </Link>
              </MenuItem>
              {/* shop-promos list end */}
            </SubMenu>
            {/* shop-promo submenu end */}

            <SubMenu
              title="Offers"
              icon={<img src={gift} alt="" className={classes.iconImage} />}
              className={
                path === "/create-offer" || path === "/offer-list"
                  ? classes.active
                  : ""
              }
            >
              <MenuItem>
                <Link to="/create-offer">
                  <img src={edit2} alt="" className={classes.iconImageSub} />{" "}
                  Create Offer
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/offer-list">
                  <img src={list} alt="" className={classes.iconImageSub} />
                  Offer List
                </Link>
              </MenuItem>
            </SubMenu>
            <SubMenu
              title="Push Notifications"
              icon={<img src={bell} alt="" className={classes.iconImage} />}
              className={
                path === "/send-notification" || path === "/notification-list"
                  ? classes.active
                  : ""
              }
            >
              <MenuItem>
                <Link to="/send-notification">
                  <img src={send} alt="" className={classes.iconImageSub} />{" "}
                  Send Notification
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/notification-list">
                  <img
                    src={notificationList}
                    alt=""
                    className={classes.iconImageSub}
                  />
                  Notification List
                </Link>
              </MenuItem>
            </SubMenu>
            <SubMenu
              title="Manage Role"
              icon={
                <img src={manage_role} alt="" className={classes.iconImage} />
              }
              className={
                path === "/create-role" || path === "/view-role"
                  ? classes.active
                  : ""
              }
            >
              <MenuItem>
                <Link to="/create-role">
                  <img
                    src={create_role}
                    alt=""
                    className={classes.iconImageSub}
                  />{" "}
                  Create Role
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/view-role">
                  <img
                    src={view_role}
                    alt=""
                    className={classes.iconImageSub}
                  />
                  View Role
                </Link>
              </MenuItem>
            </SubMenu>
            <SubMenu
              title="Manage User"
              icon={<img src={lock} alt="" className={classes.iconImage} />}
              className={
                path === "/add-user" || path === "/view-user"
                  ? classes.active
                  : ""
              }
            >
              <MenuItem>
                <Link to="/add-user">
                  <img src={userAdd} alt="" className={classes.iconImageSub} />{" "}
                  Add User
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/view-user">
                  <img
                    src={view_role}
                    alt=""
                    className={classes.iconImageSub}
                  />
                  View User
                </Link>
              </MenuItem>
            </SubMenu>

            {/* <MenuItem
              icon={<img src={faq} alt="" className={classes.iconImage} />}
            >
              <Link
                to="/manage-faq"
                className={path === "/manage-faq" ? classes.active : ""}
              >
                Manage FAQ
              </Link>
            </MenuItem>
            <MenuItem
              icon={<img src={video} alt="" className={classes.iconImage} />}
            >
              <Link
                to="/how-to-videos"
                className={path === "/how-to-videos" ? classes.active : ""}
              >
                How to Videos
              </Link>
            </MenuItem> */}
            <SubMenu
              title="Analytics"
              icon={
                <img
                  src={analyticsIcon}
                  alt=""
                  className={classes.iconImage}
                  style={{ width: 23, color: "#ededed" }}
                />
              }
              className={
                path === "/daily-active-user" ||
                  path === "/monthly-active-user" ||
                  path === "/today-register-user"
                  ? classes.active
                  : ""
              }
            >
              <MenuItem>
                <Link to="/daily-active-user">
                  <img src={userAdd} alt="" className={classes.iconImageSub} />{" "}
                  Daily Active User
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/monthly-active-user">
                  <img src={userAdd} alt="" className={classes.iconImageSub} />{" "}
                  Monthly Active User
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/today-register-user">
                  <img src={userAdd} alt="" className={classes.iconImageSub} />{" "}
                  Today Register User
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/notification-analytic">
                  <img src={userAdd} alt="" className={classes.iconImageSub} />{" "}
                  Notification Analytic
                </Link>
              </MenuItem>
            </SubMenu>
            <MenuItem icon={<GetAppIcon className={classes.iconImage} />}>
              <Link
                to="/export-transaction-data"
                className={
                  path === "/export-transaction-data" ? classes.active : ""
                }
              >
                Export Transactions
              </Link>
            </MenuItem>
          </Menu>
        </ProSidebar>
      </div>
    </>
  );
};

export default SideBar;
